import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Col, Row, Button } from "react-bootstrap";
import { get, isArray } from "lodash";
import { Field } from "../fieldComponent";
import {
  getRolesByIdAction,
  getCategoryAction,
  createGroupAction,
  getParentGroupsByCategory
} from "../../../actions/userManagement.action";
import { ERROR_MSG, STATUS } from "../../../constant";
import PermissionHOC from "../../PermissionHOC";
import { modifyDataForPost } from "../helper";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import {
  isValidArray,
  setLocalstorage,
  searchByValueHelper
} from "../../../helper";
import { InfoIcon } from "../../infoIcon";
import DisplayByPermission from "../../../component/DisplayByPermission";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import CustomDropdown from "../../reusableComponent/Dropdown/CustomDropdown";
import DropdownArrow from "../../../assets/drop-down-arrow-user-group.svg";
class CreateGroupForm extends Component {
  constructor(props) {
    super(props);
    //this.modalRef = React.createRef();
    this.state = {
      name: "",
      description: "",
      category: "",
      parentId: "",
      rolesList: [],
      error: {},
      dataUnsaved: false,
      allowPrompt: true
    };
  }

  componentDidMount = async () => {
    const { getCategoryDispatch, isEdit } = this.props;
    document.addEventListener("mousedown", this.handleClickOutside);
    getCategoryDispatch(undefined);
    if (isEdit) {
      this.onEditGroup();
    }
  };

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  onBlur = value => {};
  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef =
      this.props.groupModalRef && this.props.groupModalRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);
    console.log(dataUnsaved, allowPrompt, event.button === 0);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp();
          return;
        }
      }
    }
  };

  onEditGroup = async () => {
    const {
      groupData,
      getRolesDispatch,
      getParentGroupsByCategory
    } = this.props;
    const {
      name,
      description,
      category,
      groupCode,
      parentId,
      groupRoles,
      id
    } = groupData;
    getParentGroupsByCategory(category).then(resp => {
      let { data } = resp;
      this.setState({
        groups: data
      });
    });
    const response = await getRolesDispatch(undefined, { groupId: parentId });
    if (response) {
      const { data = {} } = response;
      if (data) {
        const rolesData = data.data;
        const rolesList = rolesData.map(role => {
          role.checked = groupRoles.find(group => group.roleId === role.roleId);
          return role;
        });
        isValidArray(rolesData) &&
          this.setState({
            rolesList
          });
      }
    }

    this.setState({
      name,
      description,
      category,
      parentId,
      id,
      groupCode,
      error: {
        name: { error: false },
        description: { error: false },
        parentId: { error: false },
        category: { error: false },
        rolesList: { error: false },
        groupCode: { error: false }
      }
    });
  };
  onChangeCatagory = (value, key) => {
    const { getRolesDispatch, getParentGroupsByCategory } = this.props;
    const { groups } = this.state;
    this.setState(async prevState => {
      isArray(prevState[key])
        ? (prevState[key] = [...prevState[key], value])
        : (prevState[key] = value);
      if (key === "category" && value == "") {
        this.setState(prevState => ({
          category: value,
          error: {
            category: {
              error: true,
              message: "This field is required"
            }
          }
        }));
      }
      if (key === "category") {
        this.setState(prevState => ({
          category: value,
          error: {
            category: {
              error: false,
              message: false
            }
          }
        }));
        getParentGroupsByCategory(value).then(resp => {
          let { data } = resp;
          this.setState({
            groups: data
          });
        });
      }

      if (key === "parentId") {
        let selectedParent = (groups || []).find(item => item.id === +value);
        this.setState(
          {
            rolesList: [],
            groupCode: selectedParent.groupCode,
            error: { ...this.state.error, ...{ groupCode: { error: false } } }
          },
          async () => {
            const response = await getRolesDispatch(undefined, {
              groupId: value
            });
            if (response) {
              const { data } = response;
              isValidArray(data.data) &&
                this.setState({
                  rolesList: data.data
                });
            }
          }
        );
      }
      this.setState({ dataUnsaved: false });
      return {
        [key]: prevState[key]
      };
    });
  };
  // onChange = (value, key) => {
  //   const { getRolesDispatch, getParentGroupsByCategory } = this.props;
  //   const { groups } = this.state;

  //   this.setState(async prevState => {
  //     isArray(prevState[key])
  //       ? (prevState[key] = [...prevState[key], value])
  //       : (prevState[key] = value);

  //     if (key === "category") {
  //       getParentGroupsByCategory(value).then(resp => {
  //         let { data } = resp;
  //         this.setState({
  //           groups: data
  //         });
  //       });
  //     }

  //     if (key === "parentId") {
  //       let selectedParent = (groups || []).find(item => item.id === +value);
  //       this.setState(
  //         {
  //           rolesList: [],
  //           groupCode: selectedParent.groupCode,
  //           error: { ...this.state.error, ...{ groupCode: { error: false } } }
  //         },
  //         async () => {
  //           const response = await getRolesDispatch(undefined, {
  //             groupId: value
  //           });
  //           if (response) {
  //             const { data } = response;
  //             isValidArray(data.data) &&
  //               this.setState({
  //                 rolesList: data.data
  //               });
  //           }
  //         }
  //       );
  //     }
  //     this.setState({ dataUnsaved: true });
  //     return {
  //       [key]: prevState[key]
  //     };
  //   });
  // };
  onChange = (value, key) => {
    const { getRolesDispatch, getParentGroupsByCategory } = this.props;

    // 1. Plain synchronous update (no async, no mutation of prevState)
    this.setState(prevState => ({
      [key]: isArray(prevState[key]) ? [...prevState[key], value] : value,
      dataUnsaved: true
    }));

    // 2. Category changed -> load parent groups
    if (key === "category") {
      getParentGroupsByCategory(value).then(resp => {
        const { data } = resp;
        this.setState({ groups: data });
      });
    }

    // 3. Parent changed
    if (key === "parentId") {
      const groups = this.state.groups || [];
      const selectedParent = groups.find(item => item.id === +value);

      // Deselected ("-Select Parent ID-") or not found: reset dependent fields
      if (!selectedParent) {
        this.setState(prevState => ({
          rolesList: [],
          groupCode: "",
          error: {
            ...prevState.error,
            parentId: { error: true, message: ERROR_MSG.DEFAULT_MSG },
            groupCode: { error: false, message: false }
          }
        }));
        return;
      }

      this.setState(
        prevState => ({
          rolesList: [],
          groupCode: selectedParent.groupCode,
          error: {
            ...prevState.error,
            parentId: { error: false, message: false },
            groupCode: { error: false, message: false }
          }
        }),
        async () => {
          const response = await getRolesDispatch(undefined, {
            groupId: value
          });
          if (response) {
            const { data } = response;
            isValidArray(data.data) && this.setState({ rolesList: data.data });
          }
        }
      );
    }
  };
  /**
   * @param error
   * @param key
   */

  onError = (error, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: error
      }
    }));
  };

  // onValidateForm = async () => {
  //   const { error = {} } = this.state;
  //   if (
  //     get(error, "name") &&
  //     !get(error, "name.error") &&
  //     get(error, "description") &&
  //     !get(error, "description.error") &&
  //     get(error, "category") &&
  //     !get(error, "category.error") &&
  //     get(error, "groupCode") &&
  //     !get(error, "groupCode.error") &&
  //     get(error, "parentId") &&
  //     get(error, "rolesList") &&
  //     !get(error, "parentId.error") &&
  //     !get(error, "rolesList.error")
  //   ) {
  //     this.openConfirmationAlert();
  //   } else {
  //     this.setState(prevState => {
  //       prevState.error.name = {
  //         error: !prevState.name,
  //         message: !prevState.name && ERROR_MSG.DEFAULT_MSG
  //       };
  //       prevState.error.description = {
  //         error: !prevState.description,
  //         message: !prevState.description && ERROR_MSG.DEFAULT_MSG
  //       };
  //       prevState.error.category = {
  //         error: !prevState.category,
  //         message: !prevState.category && ERROR_MSG.DEFAULT_MSG
  //       };
  //       prevState.error.parentId = {
  //         error: !prevState.parentId,
  //         message: !prevState.parentId && ERROR_MSG.DEFAULT_MSG
  //       };
  //       prevState.error.groupCode = {
  //         error: !prevState.groupCode,
  //         message: !prevState.groupCode && ERROR_MSG.DEFAULT_MSG
  //       };
  //       prevState.error.rolesList = {
  //         error: !prevState.rolesList.filter(role => role.checked).length,
  //         message:
  //           !prevState.rolesList.filter(role => role.checked).length &&
  //           ERROR_MSG.DEFAULT_MSG
  //       };
  //       return {
  //         error: {
  //           ...prevState.error
  //         }
  //       };
  //     });
  //     toast.error(
  //       <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
  //       errorToastStyle
  //     );
  //   }
  // };

  onValidateForm = async () => {
    const {
      name,
      description,
      category,
      parentId,
      groupCode,
      rolesList = []
    } = this.state;

    const isBlank = value =>
      value === undefined ||
      value === null ||
      (typeof value === "string" && !value.trim());

    const hasCheckedRole = rolesList.some(role => role.checked);

    const error = {
      name: {
        error: isBlank(name),
        message: isBlank(name) && ERROR_MSG.DEFAULT_MSG
      },
      description: {
        error: isBlank(description),
        message: isBlank(description) && ERROR_MSG.DEFAULT_MSG
      },
      category: {
        error: isBlank(category),
        message: isBlank(category) && ERROR_MSG.DEFAULT_MSG
      },
      parentId: {
        error: isBlank(parentId),
        message: isBlank(parentId) && ERROR_MSG.DEFAULT_MSG
      },
      groupCode: {
        error: isBlank(groupCode),
        message: isBlank(groupCode) && ERROR_MSG.DEFAULT_MSG
      },
      rolesList: {
        error: !hasCheckedRole,
        message: !hasCheckedRole && ERROR_MSG.DEFAULT_MSG
      }
    };

    const isValid = Object.values(error).every(field => !field.error);

    // Update state immutably (don't mutate prevState)
    this.setState({ error });

    if (isValid) {
      this.openConfirmationAlert();
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  onSubmit = async () => {
    this.setState({ isApiLoading: STATUS.LOADING, searchRoles: "" });
    const {
      createCategoryDispatch,
      togglePopUp,
      callApiOnSuccess
    } = this.props;
    this.openConfirmationAlert();
    togglePopUp();
    const data = modifyDataForPost(this.state);
    const response = await createCategoryDispatch(undefined, data);
    if (response) {
      const { status, message, data } = response;
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      await callApiOnSuccess();
      this.setState({ isApiLoading: STATUS.SUCCESS });
      status && setLocalstorage("editkey", data.data);
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
      this.setState({ isApiLoading: STATUS.SUCCESS, dataUnsaved: false });
    }
  };

  getFilteredData = sortedListingArr => {
    this.setState({
      sortedListingArr: get(sortedListingArr, "sortData", []),
      isSearching: get(sortedListingArr, "isSearching")
    });
  };

  onChangeSearch = value => {
    this.setState(prevState => {
      const rolesListAfterSearch = searchByValueHelper(
        prevState.rolesList,
        value,
        ["roleName"]
      );
      return {
        rolesSearch: value,
        rolesList: [...rolesListAfterSearch]
      };
    });
  };

  onSelectRole = e => {
    const { value } = e.target;
    this.setState(prevState => {
      let currentRole = prevState.rolesList.find(obj => obj.roleId === +value);
      currentRole.checked = !currentRole.checked;
      return {
        rolesList: [...prevState.rolesList],
        error: {
          ...prevState.error,
          rolesList: {
            error: !prevState.rolesList.filter(role => role.checked).length,
            message:
              !prevState.rolesList.filter(role => role.checked).length &&
              ERROR_MSG.DEFAULT_MSG
          }
        },
        dataUnsaved: true
      };
    });
  };

  render() {
    const { categoryList, isApiLoading, isEditGroup, permission } = this.props;
    const {
      showAlert,
      name: stateName,
      description: stateDescription,
      category: stateCategory,
      parentId: stateParentId,
      groupCode: stateGroupCode,
      rolesList: stateRolesList = [],
      error,
      groups
    } = this.state;
    const { name, category, parentId, description, groupCode } = error;

    let isPermission = false;
    const groupPermission = (stateRolesList || []).find(
      value => value.permission === true
    );
    if (groupPermission) {
      isPermission = true;
    }

    return (
      <React.Fragment>
        <Form name="createGroup" className="ml-n4 mt-3">
          <ConfirmationComponent
            show={showAlert}
            isLoading={isApiLoading === STATUS.LOADING}
            modalClass={"confirmation-modal"}
            saveHandler={this.onSubmit}
            closeHandler={this.openConfirmationAlert}
            content={"Are you sure you want to do this?"}
          />
          <Form.Group as={Row} controlId="formPlaintextEmail">
            <Form.Label className="group-label label-style">
              Name
              <span className="required">*</span>
            </Form.Label>
            <Col>
              <Field
                type="text"
                keyName="name"
                onChange={this.onChange}
                disabled={get(permission, "canViewOnlyProject")}
                onError={this.onError}
                delay={1000}
                value={stateName || ""}
                isInvalid={get(name, "error")}
                isRequired
                placeholder="Enter Group Name"
                className="field-width"
                onBlur={this.onBlur}
              />
              <Form.Control.Feedback type="invalid">
                {get(name, "message")}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="formPlaintextEmail">
            <Form.Label className="group-label label-style group-heading">
              Description
              <span className="required">*</span>
            </Form.Label>
            <Col>
              <Field
                type="text"
                as="textarea"
                keyName="description"
                onChange={this.onChange}
                disabled={get(permission, "canViewOnlyProject")}
                onError={this.onError}
                delay={0}
                value={stateDescription || ""}
                isRequired
                isInvalid={get(description, "error")}
                placeholder="Type Description"
                className="description-field"
                onBlur={this.onBlur}
              />
              <Form.Control.Feedback type="invalid">
                {get(description, "message")}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="category">
            <Form.Label className="group-label label-style group-heading">
              Category
              <span className="required">*</span>
            </Form.Label>
            <Col>
              <CustomDropdown
                options={[
                  { value: "", label: "-Select Category-" },
                  ...get(categoryList, "data", []).map(item => ({
                    value: item,
                    label: item
                  }))
                ]}
                height={"43px"}
                width={"555px"}
                className={"user-group"}
                page={"user-group"}
                menuClassName={"userGroupMenu"}
                onChange={this.onChangeCatagory}
                value={stateCategory}
                disabled={get(permission, "canViewOnlyProject")}
                DropdownArrow={DropdownArrow}
                error={get(category, "error")}
              />
              <div className="user-group-error mt-1">
                {get(category, "message")}
              </div>
              {/* <Field
                as="select"
                keyName="category"
                onChange={this.onChange}
                onError={this.onError}
                isInvalid={get(category, "error")}
                value={stateCategory}
                className={`category ${get(permission, "canViewOnlyProject") &&
                  "disable-dropdown-field"}`}
                disabled={get(permission, "canViewOnlyProject")}
                onBlur={this.onBlur}
              >
                <option value="" className="">
                  -Select Category-
                </option>
                {get(categoryList, "data", []).map(value => {
                  return (
                    <option value={value} selected={value === stateCategory}>
                      {value}
                    </option>
                  );
                })}
              </Field> */}
              <Form.Control.Feedback type="invalid">
                {get(category, "message")}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="category">
            <Form.Label className="group-label label-style group-heading">
              Parent Id
              <span className="required">*</span>
            </Form.Label>
            <Col>
              <Field
                as="select"
                keyName="parentId"
                className={`parentId ${get(permission, "canViewOnlyProject") &&
                  "disable-dropdown-field"}`}
                onChange={this.onChange}
                onError={this.onError}
                isInvalid={get(parentId, "error")}
                value={stateParentId}
                disabled={get(permission, "canViewOnlyProject")}
                onBlur={this.onBlur}
              >
                <option value=""> -Select Parent ID-</option>
                {(groups || []).map(value => {
                  return (
                    <option className="select-dropdown" value={value.id}>
                      {value.name}
                    </option>
                  );
                })}
              </Field>
              <Form.Control.Feedback type="invalid">
                {get(parentId, "message")}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="formPlaintextEmail">
            <Form.Label className="group-label label-style group-heading">
              Group Code
              <span className="required">*</span>
              <InfoIcon
                containerClass="email-tooltip2"
                Template={
                  "This is the recommended Project code used for all the projects/issues of this group."
                }
              />
            </Form.Label>
            <Col>
              <Field
                type="text"
                keyName="groupCode"
                onChange={this.onChange}
                disabled={get(permission, "canViewOnlyProject")}
                onError={this.onError}
                value={stateGroupCode || ""}
                isInvalid={get(groupCode, "error")}
                isRequired
                placeholder="Enter Group Code"
                className="field-width"
                onBlur={this.onBlur}
              />
              <Form.Control.Feedback type="invalid">
                {get(groupCode, "message")}
              </Form.Control.Feedback>
            </Col>
          </Form.Group>

          {stateRolesList.length !== 0 ? (
            <Form.Group as={Row} controlId="category">
              <Form.Label className="select-group group-roles-heading label-style">
                Roles
                <span className="required">*</span>
              </Form.Label>
              <Col>
                <div className="select-role group">
                  {isValidArray(stateRolesList)
                    ? stateRolesList.map(value => {
                        const {
                          roleName,
                          roleId,
                          display,
                          checked,
                          permission
                        } = value;
                        if (display === false) {
                          return null;
                        }
                        if (permission !== true) {
                          return (
                            <div
                              value={value.id}
                              className="selected-group-role selected-group-role-style selected-role"
                            >
                              <Form.Label aria-label={roleName} />
                              <Form.Check
                                type="checkbox"
                                value={roleId}
                                id={roleName}
                                label={roleName}
                                checked={checked}
                                onChange={this.onSelectRole}
                                disabled={
                                  this.props.isEdit &&
                                  this.props.permission.canViewOnlyProject
                                }
                                className={`form-checkbox ${
                                  checked &&
                                  !get(permission, "canViewOnlyProject")
                                    ? `checked`
                                    : ""
                                }${
                                  this.props.isEdit &&
                                  this.props.permission.canViewOnlyProject
                                    ? "checked checked-disable"
                                    : ""
                                }`}
                              />
                            </div>
                          );
                        }
                      })
                    : null}
                </div>
              </Col>
            </Form.Group>
          ) : null}

          {stateRolesList.length !== 0 && isPermission && (
            <Form.Group as={Row} controlId="category">
              <Form.Label className="select-group label-style  mt-0">
                Permissions
              </Form.Label>
              <Col>
                <div className="select-role group">
                  {stateRolesList.map(value => {
                    const {
                      roleName,
                      roleId,
                      display,
                      checked,
                      permission
                    } = value;
                    if (permission) {
                      return (
                        <div
                          value={value.id}
                          className="selected-group-role selected-role selected-group-role-style"
                        >
                          <Form.Label aria-label={roleName} />
                          <Form.Check
                            type="checkbox"
                            value={roleId}
                            id={roleName}
                            label={roleName}
                            checked={checked}
                            onChange={this.onSelectRole}
                            disabled={
                              this.props.isEdit &&
                              this.props.permission.canViewOnlyProject
                            }
                            className={`form-checkbox ${
                              checked && !get(permission, "canViewOnlyProject")
                                ? `checked`
                                : ""
                            }${
                              this.props.isEdit &&
                              this.props.permission.canViewOnlyProject
                                ? "checked checked-disable"
                                : ""
                            }`}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
              </Col>
            </Form.Group>
          )}
          <DisplayByPermission display={!get(permission, "canViewOnlyProject")}>
            <Button
              className="btn-orange edit-create-group-btn rounded mt-3"
              onClick={this.onValidateForm}
            >
              {isEditGroup ? "Update" : "Submit"}
            </Button>
          </DisplayByPermission>
        </Form>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    permissionListing: state.commonReducer.permissionsListing,
    categoryList: state.userManagementReducer.categoryList,
    isApiLoading: state.userManagementReducer.isApiLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRolesDispatch: getRolesByIdAction,
      getCategoryDispatch: getCategoryAction,
      createCategoryDispatch: createGroupAction,
      getParentGroupsByCategory
    },
    dispatch
  );
}

export default PermissionHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateGroupForm)
);
